// Author thq
// Date 2021-06-09 10:13:09

class EmAcctType {
constructor({
        id = null,
        parentId = '',
        name = '',
        seq = '',
        remark = ''}
= {}) {
    this.id = id;
    this.parentId = parentId;
    this.name = name;
    this.seq = seq;
    this.remark = remark;
}
}

function newEntity() {
return new EmAcctType();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.accident.emAcctType.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentId',
        label: 'label.em.accident.emAcctType.grid.parentId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'level',
        label: 'label.em.accident.emAcctType.grid.level',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.em.accident.emAcctType.grid.nodeCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.accident.emAcctType.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.em.accident.emAcctType.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.accident.emAcctType.grid.remark',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    parentIdFilter : "",
    levelFilter : "",
    nameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'parentIdFilter',
        label: 'label.em.accident.emAcctType.filter.parentId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchFaultType'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'levelFilter',
        label: 'label.em.accident.emAcctType.filter.level',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.accident.emAcctType.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'parentId',
        label: 'label.em.accident.emAcctType.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAcctType'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'name',
        label: 'label.em.accident.emAcctType.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'seq',
        label: 'label.em.accident.emAcctType.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.em.accident.emAcctType.entity.remark',
        sortable: true,
        isDetail: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmAcctType, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
